import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/ptsc/1.png'


const _withScopeId = n => (_pushScopeId("data-v-8752db0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resource-plaza-ctn flex-column" }
const _hoisted_2 = { class: "search-ctn flex-row" }
const _hoisted_3 = { class: "list flex-1 list_1" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "info-ctn flex-column" }
const _hoisted_6 = { class: "van-ellipsis" }
const _hoisted_7 = { class: "indel" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = { class: "time" }
const _hoisted_11 = { class: "img-ctn" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "list flex-1 list_policy list_2" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  class: "info-ctn flex-column",
  style: {"width":"100%"}
}
const _hoisted_16 = { class: "van-ellipsis" }
const _hoisted_17 = { class: "time" }
const _hoisted_18 = { class: "jj" }
const _hoisted_19 = { style: {"display":"inline-block","margin-left":"15px"} }
const _hoisted_20 = { class: "list flex-1" }
const _hoisted_21 = { class: "div_del" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("找运营，上“营城”")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("【营城小程序使用手册】")
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<p class=\"tit\" data-v-8752db0a>1. 为什么要做这样一个平台？</p><p class=\"text\" data-v-8752db0a> 城市更新时代，城市经营成败的关键在于为城市空间找到合适的运营商，通过运营内容的嵌入，实现空间的盘活与保值增值。 </p><p class=\"text\" data-v-8752db0a> 不同于增量时代的“成片开发”的同质化和规模化，存量时代的城市运营空间较为“碎片化”，类型多，规模小，分布广；而运营的业态和内容则呈现出“个性化”的特点，远远超出了传统的购物、餐饮等业态范畴。这就导致了<span data-v-8752db0a>政府找不到运营商，运营商找不到切入路径”</span>成为了城市经营和存量更新的核心痛点。 </p><p class=\"text\" data-v-8752db0a><span data-v-8752db0a>“营城”城市空间资产经营信息平台</span>由厦门大学规划设计研究院开发，借助央企、央校和大师专家的资源赋能，致力于解决城市经营中空间产权人与市场运营主体之间的信息不对称的问题。 </p><p class=\"text\" data-v-8752db0a><span data-v-8752db0a>“营城”城市空间资产经营信息平台</span><span style=\"color:#000;font-weight:bold;\" data-v-8752db0a>由厦门大学赵燕菁教授团队负责运营，与“存量规划前沿”公众号互联互通，</span>共筑“城市经营”的微信生态。面向全国各城市，该平台致力于帮助空间资产产权人（地方政府或者国资平台公司）找到运营商，同时帮助运营商、主理人找到适合自己的运营场所。我们的目标是让再小的城市空间也能链接到全国最优秀的运营资源，再小的运营品牌也能找到最优质的空间舞台。 </p><p class=\"text\" data-v-8752db0a> 找运营，上“营城”，让城市经营不再困难。该平台主要包括三项服务：资产摸排、资产包装和信息分发。资产摸排是面向地方政府或国资平台公司，帮助其研判具有经营潜力的城市空间，并摸排现状空间及财务经营信息家底；资产包装则是通过对接运营商需求，为城市空间策划项目并提请主管部门“预审批”，明确空间利用的底线要求（包括空间使用要求，特许经营权租金要求等）；信息分发则是把“预审批”通过后的空间资源“上架”小程序平台，向更多的运营商进行招商。 </p><p class=\"text\" data-v-8752db0a> 在这里，你可以查询全国各大城市最优质的存量空间信息；你可以链接海内外最优质的运营商和主理人；你可以借鉴最前沿的存量空间策划包装思路；你也可以对外发布你想运营的空间类型或者你想合作的运营主体；你也可以为已经上线的空间资源重新设计策划方案并上传…… </p>", 7)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 2. 平台是给谁用？")
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<p class=\"text\" data-v-8752db0a> 产品主要面向<span data-v-8752db0a>地方政府（包括国有资产平台公司）和市场运营主体。</span>其他类型的用户，如代建公司、设计师、咨询机构等，也可以利用该产品寻找合适的项目资源，寻求项目合作。 </p><p class=\"text\" data-v-8752db0a><span data-v-8752db0a>地方政府和国资平台公司</span>，可利用该平台，“上线”对外发布国有的存量空间资源信息，包括但不限于：公房、公园、绿地、广场、道路、未利用地、商办物业、市政设施等。同时，平台方运营方（赵燕菁教授团队）将提供项目包装策划服务，帮助地方政府和国资平台公司，谋划并制定每宗地块的更新思路和运营条件（包括项目初步策划方案、商业模式设计、财务数据测算、相关用地审批政策规定、对运营方的租金、税收及其他运营要求等）。 </p><p class=\"text\" data-v-8752db0a><span data-v-8752db0a>市场运营主体</span>可利用该平台，搜索查询各个城市、不同类型的存量空间资源信息，包括但不限于：空间位置、产权信息、现状利用情况以及运营条件（已通过主管部门“预审批”会议确定的底线要求）等。市场运营主体在找到合适的空间资源后，可一键申请成为该项目的运营方。申请后，平台运营方将迅速介入，帮助运营商与地方政府（包括国有资产平台公司）进一步沟通项目落地事宜，直至达成最终的合作。 </p><div style=\"text-align:center;margin:10px auto;\" data-v-8752db0a><img src=\"" + _imports_0 + "\" alt=\"图片\" style=\"width:80%;\" data-v-8752db0a></div>", 4)
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 3.这个平台有什么不一样吗？")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "“营城”平台具备“精准匹配，广泛触达，持续服务”的优势和特点", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "精准匹配——", -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode("根据运营商的需求，定制化策划存量空间的更新方案，设计兼顾各方利益“最大公约数”的空间使用和运营条件，帮助“碎片化”的存量空间精准找到适合的运营主体，也帮“个性化”的运营商和主理人找到精准满足自身需求的空间资源。")
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "广泛触达——", -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode("平台将整合全国不同城市、区域、类型的空间资源信息，同时集结数量众多、背景多元的来自全国各地的运营主体。让空间资源触达更多的运营主体，让运营主体触达更丰富的空间资源，提高相互匹配的成功率。")
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "持续服务——", -1))
const _hoisted_43 = /*#__PURE__*/_createTextVNode("根据年度计划，帮助地方政府和国有资产平台公司不断往平台“上架”更多的存量空间资源，动态调整项目策划方案和运营条件。帮助运营商持续深化和拓展与地方政府的合作关系，获得更多更优质的空间资源以及更“优惠”的运营条件。")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("4.平台应该如何操作使用？")
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<p class=\"text\" data-v-8752db0a><span data-v-8752db0a>A.用户认证功能——</span>地方政府和国有资产平台公司可委托授权相关经办人员，以政府或者国资平台公司的名义，上传相关材料，申请用户认证。 </p><p class=\"text\" data-v-8752db0a>运营主体可以公司或者主理人（个人）的名义，上传相关材料，申请用户认证。</p><p class=\"text\" data-v-8752db0a> 其他类型的用户（如代建公司、设计师、咨询机构等）分别按照企业用户和个人用户的相关规定，上传相关材料，申请用户认证。 </p><p class=\"text\" data-v-8752db0a>未认证用户也具备对部分信息进行查询的权限，但无法使用包括需求发布在内的其他功能。</p><p class=\"text\" data-v-8752db0a><span data-v-8752db0a>B.项目查询与申请功能——</span>认证后的用户，可通过首页、资源广场和资源地图查询项目的具体信息。可以在资源广场和资源地图中，按照不同的城市、用地类型以及其他条件，筛选搜寻适合的项目地块，在地块详情界面点击“我来运营”，一键申请成为项目的运营方。 </p><p class=\"text\" data-v-8752db0a><span data-v-8752db0a>C.需求发布功能——</span>认证后的用户，可通过“发需求”对外发布需求。地方政府和国有资产平台公司可利用该功能，联系平台运营方“上架”更多的城市存量空间资源，并对外广泛招募运营商；运营主体也可利用该功能，寻找并联系合适的空间资源及其产权人。需求发布后，平台将第一时间与用户取得联系。经平台审核后，用户所发布的需求内容也将同步更新在小程序的“论坛”中，向其他用户展示。其他类型的用户（如设计师、代建公司、咨询机构等），也可以利用该功能模块发布自身的需求。 </p><p class=\"text\" data-v-8752db0a><span data-v-8752db0a>D.资讯与论坛功能——</span>全体用户（包括未认证用户）可在资源下方点击在线咨询，即可咨询详细信息，在资讯板块，查看最新最前沿的有关城市经营和城市更新的政策文件、公众号文章和相关资讯。认证后的用户，可在“论坛”中使用发帖和跟帖回复功能。 </p>", 7)

import wx from "weixin-js-sdk"
import { ref, onMounted, onActivated } from "vue"
import Cities from "@/components/Cities.vue"
import ListWithRefreshAndLazyLoad from "@/components/ListWithRefreshAndLazyLoad.vue"
import router from "@/router"
import { useRoute } from "vue-router"
import { informationSearchApi, policySearchApi, informationDetailApi } from "@/api/policy"
import { addFeedBackApi } from "@/api/home"
import { getToken } from "@/utils/cookies"
import DataList from "@/api/common"

const __default__ = {
  name: "Policy"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const listRef: any = ref(null)
const listRefPolicy: any = ref(null)
const route = useRoute()
const isHomeSearch = ref(false)
const searchTitle = ref("")
const params: any = ref({
  title: searchTitle
})
const paramsCopy: any = ref({
  subClass: ""
})
const paramsPolicy: any = ref({
  title: searchTitle
})
const subClass: any = ref(["资讯", "政策", "平台手册"])
const list: any = ref([])
const listPolicy: any = ref([])
const rateVal: any = ref(4)
const gotoDetail = (item: any) => {
  // 缓存滚动条滚动的高度
  const height: any = document.getElementsByClassName("list_1")[0].scrollTop
  sessionStorage.setItem("policy1Scroll", height)
  if (item.isLink == 1) {
    // window.open(item.linkUrl)
    //记录浏览量
    const datas = {
      originalSfid: item.sfid,
      type: "info"
    }
    addFeedBackApi(datas).then(() => {})
    console.log("第三方链接")
    console.log(item.linkUrl)
    wx.miniProgram.navigateTo({
      url: `/pages/webview/webview?previewUrl=${item.linkUrl}`
    })
    // router.push({ path: "/webView", query: { url: item.linkUrl } })
    // 调用详情接口  记录浏览量
    informationDetailApi(item.sfid).then()
  } else {
    //记录浏览量
    const datas = {
      originalSfid: item.sfid,
      type: "info"
    }
    addFeedBackApi(datas).then(() => {})
    router.push({ path: "/policy/detail", query: { id: item.sfid, from: "information" } })
  }
}
const gotoPolicy = (item: any) => {
  // 缓存滚动条滚动的高度
  const height: any = document.getElementsByClassName("list_2")[0].scrollTop
  sessionStorage.setItem("policy2Scroll", height)
  router.push({ path: "/policy/detail", query: { id: item.sfid, from: "policy" } })
}
// const onSearch = (val: string) => {
//   params.value.key = val
//   list.value = []
// }
const onClear = () => {
  // 重新搜索
  // reSearch()
  // searchTitle.value = ""
}
const reSearch = () => {
  if (paramsCopy.value.subClass == "资讯") {
    // setTimeout(() => {
    //   list.value = []
    //   listRef.value.onRefresh()
    // }, 100)
  } else if (paramsCopy.value.subClass == "政策") {
    setTimeout(() => {
      listPolicy.value = []
      listRefPolicy.value.onRefresh()
    }, 100)
  }
}
onActivated(() => {
  if (route.meta.isReach) {
    list.value = []
    listRef.value.onRefresh()
  }
  if (route.meta.catch && !route.meta.keepAlive && !route.meta.isReach) {
    if (paramsCopy.value.subClass == "资讯") {
      const height: any = sessionStorage.getItem("policy1Scroll")
      document.getElementsByClassName("list_1")[0].scrollTop = height || 0
    } else if (paramsCopy.value.subClass == "政策") {
      const height: any = sessionStorage.getItem("policy2Scroll")
      document.getElementsByClassName("list_2")[0].scrollTop = height || 0
    }
  }
})
onMounted(() => {
  console.log(listRef)
  console.log(listRefPolicy)
})
// 获取图片预览地址
const getImg = (sfid: string) => {
  var url = DataList.UpdtImagePrefix() + sfid
  return url
}

return (_ctx: any,_cache: any) => {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_P = _resolveComponent("P")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_search, {
        modelValue: searchTitle.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((searchTitle).value = $event)),
          reSearch
        ],
        class: "system-search",
        placeholder: "输入搜索关键词",
        shape: "round",
        clearable: "",
        "show-action": "",
        onSearch: reSearch,
        onClear: onClear,
        onCancel: onClear
      }, null, 8, ["modelValue"])
    ]),
    true
      ? (_openBlock(), _createBlock(_component_van_tabs, {
          key: 0,
          active: paramsCopy.value.subClass,
          "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((paramsCopy.value.subClass) = $event)),
          class: "sub-class",
          color: "#f1c241",
          onChange: _cache[2] || (_cache[2] = ($event: any) => (reSearch()))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subClass.value, (name, i) => {
              return (_openBlock(), _createBlock(_component_van_tab, {
                key: i,
                title: name,
                name: name
              }, null, 8, ["title", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["active"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(ListWithRefreshAndLazyLoad, {
        ref_key: "listRef",
        ref: listRef,
        list: list.value,
        "onUpdate:list": _cache[3] || (_cache[3] = ($event: any) => ((list).value = $event)),
        params: params.value,
        getDataAPI: _unref(informationSearchApi),
        offset: 10
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list-item flex-row",
              key: i,
              onClick: ($event: any) => (gotoDetail(item))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", _hoisted_6, _toDisplayString(item.title), 1),
                _createElementVNode("p", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(item.publishUserName), 1),
                  _hoisted_9,
                  _createElementVNode("span", _hoisted_10, _toDisplayString(item.publishTime), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("img", {
                  fit: "cover",
                  src: getImg(item.coverResource?.sfid),
                  alt: ""
                }, null, 8, _hoisted_12)
              ])
            ], 8, _hoisted_4))
          }), 128))
        ]),
        _: 1
      }, 8, ["list", "params", "getDataAPI"])
    ], 512), [
      [_vShow, paramsCopy.value.subClass == '资讯']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _createVNode(ListWithRefreshAndLazyLoad, {
        ref_key: "listRefPolicy",
        ref: listRefPolicy,
        list: listPolicy.value,
        "onUpdate:list": _cache[4] || (_cache[4] = ($event: any) => ((listPolicy).value = $event)),
        params: paramsPolicy.value,
        getDataAPI: _unref(policySearchApi),
        offset: 20
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listPolicy.value, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list-item flex-row",
              key: i,
              onClick: ($event: any) => (gotoPolicy(item))
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h3", _hoisted_16, _toDisplayString(item.title), 1),
                _createElementVNode("p", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(item.issueDept), 1),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(item.policyFinishTime ? item.policyFinishTime.split(" ")[0].replace(/-/g, "/") : ""), 1)
                ])
              ])
            ], 8, _hoisted_14))
          }), 128))
        ]),
        _: 1
      }, 8, ["list", "params", "getDataAPI"])
    ], 512), [
      [_vShow, paramsCopy.value.subClass == '政策']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_P, { class: "tits" }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }),
        _createVNode(_component_P, { class: "tits" }, {
          default: _withCtx(() => [
            _hoisted_23
          ]),
          _: 1
        }),
        _hoisted_24,
        _createVNode(_component_P, { class: "tit" }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        }),
        _hoisted_32,
        _createVNode(_component_P, { class: "tit" }, {
          default: _withCtx(() => [
            _hoisted_36
          ]),
          _: 1
        }),
        _hoisted_37,
        _createVNode(_component_P, { class: "text" }, {
          default: _withCtx(() => [
            _hoisted_38,
            _hoisted_39
          ]),
          _: 1
        }),
        _createVNode(_component_P, { class: "text" }, {
          default: _withCtx(() => [
            _hoisted_40,
            _hoisted_41
          ]),
          _: 1
        }),
        _createVNode(_component_P, { class: "text" }, {
          default: _withCtx(() => [
            _hoisted_42,
            _hoisted_43
          ]),
          _: 1
        }),
        _createVNode(_component_P, { class: "tit" }, {
          default: _withCtx(() => [
            _hoisted_44
          ]),
          _: 1
        }),
        _hoisted_45
      ])
    ], 512), [
      [_vShow, paramsCopy.value.subClass == '平台手册']
    ])
  ]))
}
}

})